import { CustomCellRendererProps } from 'ag-grid-react';

import { isPromotedSingleChild } from 'core/utils';

import CellRendererForAgGrid from './CellRendererForAgGrid';

export const ParentRowCellRenderer = (props: CustomCellRendererProps) => {
  const isGroup = !!props.node?.group;
  const isPromoted = isPromotedSingleChild({ node: props.node });

  if (!isGroup && !isPromoted) {
    return null;
  }

  return <CellRendererForAgGrid {...props} />;
};
